module.exports = __webpack_public_path__ + "img/mentallock.d2138760.png";